import React from 'react';
import './HospitalMD.css';
import hero from '../assets/images/Doctors/5.png';

function HospitalMD() {
    return (
        <section className="hospital-md">
            <div className="md-container">
                <div className="md-card">
                    <div className="md-accent"></div>
                    <div className="md-image">
                        <img src={hero} alt="Managing Director" />
                    </div>
                    <div className="md-content">
                        <h2 className="md-name">M. Peterson Luke</h2>
                        <p className="md-title">Chairperson &amp; Managing Director</p>
                        <p className="md-bio">M. Peterson Luke is the Managing Director, providing strong strategic leadership and clear organizational direction. He is responsible for guiding the company’s vision, strengthening operational excellence, and ensuring sustainable growth across all functions.</p>
                        <p className="md-bio">With a leadership style rooted in integrity, strategic foresight, and continuous improvement, he drives initiatives that enhance quality standards, operational efficiency, and stakeholder confidence. He works closely with senior leadership and teams to foster a culture of accountability, innovation, and performance excellence.</p>

                        <div className="md-divider" aria-hidden="true"></div>
                        <div className="md-signature">
                            <svg className="md-sign-svg" viewBox="0 0 120 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6 28c12-8 28-14 52-6 20 6 38 8 56 0" stroke="#0b63c4" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" opacity="0.9"/></svg>
                            <div className="md-sign-name">M. Peterson Luke</div>
                            <div className="md-sign-role">Chairperson &amp; Managing Director</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default HospitalMD;
